// Dual-store for the auth JWT: localStorage (fast, but can be evicted by mobile
// browsers / in-app browsers) AND a first-party cookie (survives more mobile
// scenarios, incl. iOS Safari and PWA standalone contexts).
//
// Reads: prefer localStorage → cookie fallback. If only cookie present, mirror
// it back into localStorage so the rest of the app keeps working.
// Writes: write to BOTH sinks.
// Clears: clear BOTH sinks.

const KEY = 'vc_token';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 7; // 7 days — matches backend JWT_EXP_HOURS

function readCookie() {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(?:^|; )' + KEY + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(value) {
  if (typeof document === 'undefined') return;
  const secure = typeof window !== 'undefined' && window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${KEY}=${encodeURIComponent(value)}; Path=/; Max-Age=${COOKIE_MAX_AGE}; SameSite=Lax${secure}`;
}

function deleteCookie() {
  if (typeof document === 'undefined') return;
  document.cookie = `${KEY}=; Path=/; Max-Age=0; SameSite=Lax`;
}

export function getToken() {
  try {
    const ls = localStorage.getItem(KEY);
    if (ls) return ls;
  } catch { /* localStorage may be blocked in private mode */ }
  const ck = readCookie();
  if (ck) {
    // Mirror cookie back into localStorage so subsequent reads are fast and
    // consistent (best-effort — ignore quota/security errors).
    try { localStorage.setItem(KEY, ck); } catch { /* noop */ }
    return ck;
  }
  return null;
}

export function setToken(value) {
  if (!value) return;
  try { localStorage.setItem(KEY, value); } catch { /* noop */ }
  writeCookie(value);
}

export function clearToken() {
  try { localStorage.removeItem(KEY); } catch { /* noop */ }
  deleteCookie();
}
